// extracted by mini-css-extract-plugin
export var card = "_nr-0";
export var content = "_nr-2";
export var icon = "_nr-1";